import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Popover,
  PopoverTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../../../components";
import { LeadButton, type LeadButtonProps } from "./LeadButton";
import { TemperatureIcon } from "./icon";
import { TemperatureMenu } from "./menu";
import { faEdit, faEye } from "@fortawesome/free-regular-svg-icons";
import { TooltipProvider } from "@radix-ui/react-tooltip";
import { homeState } from "../../../../state/home";

interface Props extends LeadButtonProps {
  leadId: string;
}

export const LeadEditLinkButton = ({ leadId, ...props }: Props) => (
  <LeadButton {...props} tooltipText="Edit Profile Version">
    <div
      className="w-9 h-9 p-2 relative shrink-0"
      onClick={() => {
        homeState.linkCreatorLeadId = leadId ?? null;
      }}
    >
      <div>
        <FontAwesomeIcon
          width={20}
          height={20}
          icon={faEdit}
          className="w-5 h-5"
        />
      </div>
    </div>
  </LeadButton>
);
